module.exports = __webpack_public_path__ + "static/img/partner-logistics.f650c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-logistics.png
// module id = t+Us
// module chunks = 34